import { render, staticRenderFns } from "./CommonSearchAutocomplete.vue?vue&type=template&id=2272553d"
import script from "./CommonSearchAutocomplete.vue?vue&type=script&lang=js"
export * from "./CommonSearchAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports